import { openModal } from '@bn-games/ui-shell';
import { BISHOP, KNIGHT, QUEEN, ROOK, type PromotionType } from '../game/types.js';
import { t } from '../i18n/I18n.js';

const CHOICES: readonly (readonly [PromotionType, 'queen' | 'rook' | 'bishop' | 'knight'])[] = [
  [QUEEN, 'queen'],
  [ROOK, 'rook'],
  [BISHOP, 'bishop'],
  [KNIGHT, 'knight'],
];

export interface PromotionPrompt {
  /** The chosen piece type, or null on Cancel or when closed from outside. */
  readonly choice: Promise<PromotionType | null>;
  /** Close without a choice (the game it belongs to is going away). */
  readonly close: () => void;
}

/**
 * Ask which piece a pawn becomes. Not dismissible by Escape/backdrop: the
 * modal has no dismiss hook, so cancelling is an explicit button — the move
 * then simply isn't played.
 */
export function askPromotion(): PromotionPrompt {
  let settle: (type: PromotionType | null) => void = () => {};
  const choice = new Promise<PromotionType | null>((resolve) => {
    settle = resolve;
  });
  const finish = (type: PromotionType | null): void => {
    modal.close();
    settle(type);
  };
  const modal = openModal({
    title: t('promotion.title'),
    body: '',
    dismissible: false,
    actions: [
      ...CHOICES.map(([type, key], i) => ({ label: t(`promotion.${key}`), primary: i === 0, onClick: () => finish(type) })),
      { label: t('promotion.cancel'), onClick: () => finish(null) },
    ],
  });
  modal.focusPrimary();
  return { choice, close: () => finish(null) };
}
